import axios from 'axios'
import { Utils } from '@saas/lib/toktokdoc-lib/web'
import 'moment/locale/fr'
import moment from 'moment-timezone'

class SlackNotifications {
    /**
     * @static
     * @async
     * @description send notification to slack
     * @param {string} objectId
     * @param {string} type
     * @param {string} message
     * @param {Boolean} throws
     * @returns {void}
     * @memberof SlackNotifications
     */
    static async sendNotification(objectId: string, type: string, message: string, throws: boolean) {
        if (!message) return
        try {
            const token = await Utils.getSessionToken()
            await axios.post(
                `${window._env_.REACT_APP_HDS_HOST}/notify`,
                {
                    type,
                    message,
                    id: objectId,
                },
                {
                    headers: {
                        'X-Session-Token': token,
                    },
                },
            )
        } catch (e) {
            if (throws) throw e
        }
    }

    /**
     * @description send slack message when join TLC
     * @param {Consultation} consultation
     * @returns {void}
     * @memberof SlackNotifications
     */
    static joinTC(consultation: any) {
        let message
        try {
            let documents = []
            let pictures = []
            if (consultation.documents) documents = consultation.documents.map((d: any) => d.url.match(/([^/]+$)/)[1])
            if (consultation.pictures) pictures = consultation.pictures.map((p: any) => p.url.match(/([^/]+$)/)[1])
            const initialAppointmentDate = moment(consultation.initialAppointmentDate.iso)
            const effectiveAppointmentDate = moment()
            const diff = effectiveAppointmentDate.diff(initialAppointmentDate, 'minutes')
            message = `\`Démarrée\` *Visio démarrée*
• Heure prévue : ${initialAppointmentDate.format('DD/MM/YYYY - HH:mm')}
• Heure effective : ${effectiveAppointmentDate.format('DD/MM/YYYY - HH:mm')}
• Nombre de documents envoyés en salle d’attente : ${documents.length}`

            if (diff > 15) {
                message += `
• Retard supérieur à 15 minutes <!here>`
            }

            message += `
• Nombre de photos envoyés en salle d’attente : ${pictures.length}`
        } catch (error) {
            console.log(error)
        }
        // @ts-expect-error TS(2554) FIXME: Expected 4 arguments, but got 3.
        SlackNotifications.sendNotification(consultation.objectId, 'TLC', message).catch((err) => console.log(err))
    }

    /**
     * @description send slack message when join TLC failed
     * @param {Consultation} consultation
     * @param {string} [error=null]
     * @returns {void}
     * @memberof SlackNotifications
     */
    static joinTCFailed(consultation: any, error = null) {
        const message = error
            ? `<!here> Erreur ${error} lors du démarrage de la téléconsultation ${consultation.objectId}`
            : `<!here> Erreur lors du démarrage de la téléconsultation ${consultation.objectId}`
        console.log('Slack message: ', message)
        // @ts-expect-error TS(2554) FIXME: Expected 4 arguments, but got 3.
        SlackNotifications.sendNotification(consultation.objectId, 'TLC', message).catch((err) => console.log(err))
    }

    /**
     * @description send slack message when TLC end
     * @param {Consultation} consultation
     * @param {string} [totalBilledPriceStr
     * @returns {void}
     * @memberof SlackNotifications
     */
    static TCEnd(consultation: any, totalBilledPriceStr: string) {
        let message
        try {
            const csDuration = moment().diff(moment(consultation.appointmentDate.iso), 'minutes')
            message = `\`Terminée\` *Téléconsultation Terminée*
• Heure fin : ${moment().format('DD/MM/YYYY - HH:mm')}
• Durée : *${csDuration} min.*
• Montant : \`${totalBilledPriceStr}\``
        } catch (error) {
            console.log(error)
        }
        // @ts-expect-error TS(2554) FIXME: Expected 4 arguments, but got 3.
        SlackNotifications.sendNotification(consultation.objectId, 'TLC', message).catch((err) => console.log(err))
    }

    /**
     * @description send slack message when network alert by a problem
     * @param {Consultation} consultation
     * @returns {void}
     * @memberof SlackNotifications
     */
    static networkAlert(consultation: any) {
        const message = '*Anomalie de réseau requis* <!here>'
        return SlackNotifications.sendNotification(consultation.objectId, 'TLC', message, true)
    }

    /**
     * @description send slack message when network is tested
     * @param {Consultation} consultation
     * @returns {void}
     * @memberof SlackNotifications
     */
    static networkTest(consultation: any, result: string) {
        const message = `*Test de débit requis* ${result}`
        if (consultation.objectId) {
            // @ts-expect-error TS(2554) FIXME: Expected 4 arguments, but got 3.
            SlackNotifications.sendNotification(consultation.objectId, 'TLC', message).catch((err) => console.log(err))
        }
    }
}

export default SlackNotifications
